// src/components/Finanzas/ModalConfirmacionMovimiento.jsx
// Modal usado para confirmar EntregaDinero o TrasladoDinero.
// Captura observaciones del receptor. La firma digital se obtiene
// automáticamente en el backend desde la colección Signs del usuario.

import React, { useState } from 'react';
import { Modal, Form, Row, Col, Button, Alert } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';

const formatoCOP = (n) => `$${Number(n || 0).toLocaleString('es-CO')}`;

const ModalConfirmacionMovimiento = ({ show, onClose, tipo, item, processing, onConfirmar }) => {
  const [observaciones, setObservaciones] = useState('');
  const [error, setError] = useState(null);

  console.log(item)
  const esEntrega = tipo === 'entrega';

  const handleConfirmar = () => {
    setError(null);
    const datos = {
      observaciones: observaciones.trim() || undefined,
      dispositivo: navigator.userAgent.substring(0, 100)
    };
    onConfirmar(datos);
  };

  return (
    <Modal show={show} onHide={onClose} size="md" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          <FaCheckCircle className="me-2 text-success" />
          Confirmar {esEntrega ? 'entrega' : 'traslado'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="info" className="py-2">
          <Row className="g-2">
            <Col xs={6}><strong>Monto:</strong></Col>
            <Col xs={6} className="text-end">{formatoCOP(item.monto)}</Col>
            <Col xs={6}><strong>Fecha:</strong></Col>
            <Col xs={6} className="text-end">{new Date(item.fecha).toLocaleDateString('es-CO')}</Col>
            <Col xs={6}><strong>{esEntrega ? 'Origen:' : 'De:'}</strong></Col>
            <Col xs={6} className="text-end">
              {esEntrega ? (item.cuentaOrigen?.nombre || '—') : (item.cuenta_origen?.nombre || '—')}
            </Col>
            {item.descripcion && (
              <Col xs={12}><strong>Descripción:</strong> {item.descripcion}</Col>
            )}
          </Row>
        </Alert>

        <Form.Group className="mb-3">
          <Form.Label>Observaciones (opcional)</Form.Label>
          <Form.Control as="textarea" rows={2}
            value={observaciones}
            onChange={(e) => setObservaciones(e.target.value)}
            placeholder="Ej: Recibido en efectivo"
          />
        </Form.Group>

        {error && <Alert variant="danger" className="py-2">{error}</Alert>}

        <Alert variant="warning" className="py-2 mb-0 small">
          Al confirmar, el monto se registrará en tu bolsillo y se generará el comprobante contable.
          Tu firma digital almacenada en el perfil se incluirá automáticamente.
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={processing}>Cancelar</Button>
        <Button variant="success" onClick={handleConfirmar} disabled={processing}>
          {processing ? 'Confirmando...' : 'Confirmar recepción'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmacionMovimiento;
